/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Badge } from '@radix-ui/themes';

import { styled, use } from 'fierry/react';

import Time from 'solis/time';

import { formatDuration } from 'solis/claude/util/duration';


const URGENT_DURATION = 6 * 60 * 60 * 1000;


const FixedBadge = styled(Badge)`
  min-width: 3.5rem;
  justify-content: center;
  font-variant-numeric: tabular-nums;
`;


export default ({ date }) =>
{
  const now = use(Time);

  const remaining = date - now;

  const color = remaining < URGENT_DURATION ? 'ruby' : 'green';

  return <FixedBadge size = '1' color = {color}>{formatDuration(remaining)}</FixedBadge>;
};
